var map = {
	"./Herman-Lindqvist.jpg": 6715,
	"./Jinder.jpg": 9379,
	"./bellmandagen.jpg": 6844,
	"./calaisa.jpg": 1519,
	"./eric_1000.jpg": 7884,
	"./malena_mats.jpg": 1932,
	"./midsommar.jpg": 5378,
	"./schaffer.jpg": 1119,
	"./säsongsöppning.jpg": 8744,
	"./tina_bengan.jpg": 7879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9721;